import {styled} from '@mui/material'
import {Texts} from 'appearance'
import {Controller} from 'react-hook-form'
import {orientationStyles} from 'services/utils/formUtils'
import {FormErrorText} from './Form'
import Input from './Input'
import {useDeviceDetect} from 'services/hooks'

const EditableInput = ({
    name,
    label,
    LabelComponent,
    formControl,
    formErrors,
    required,
    editMode,
    rules,
    type,
    disabled,
    orientation = 'horizontal',
    readOnly,
}) => {
    const {isMobile} = useDeviceDetect()
    return (
        <Container style={orientationStyles[orientation]}>
            {LabelComponent ? (
                <LabelComponent />
            ) : (
                <Label isMobile={isMobile}>{label}</Label>
            )}
            <Controller
                name={name}
                control={formControl}
                rules={rules || {required}}
                render={({field: {onChange, value}}) =>
                    editMode && !readOnly ? (
                        <Input
                            onChange={onChange}
                            value={value === null ? undefined : value}
                            fullWidth={true}
                            required={required}
                            disabled={disabled}
                            type={type}
                            style={{flex: 3}}
                        />
                    ) : (
                        <Value>{value}</Value>
                    )
                }
            />
            {formErrors?.[name] && (
                <FormErrorText>{`valid ${label} is required`}</FormErrorText>
            )}
        </Container>
    )
}

export default EditableInput

const Container = styled('div')`
    display: flex;
`

const Label = styled(Texts.BoldText)`
    font-size: ${({isMobile}) => (isMobile ? 14 : 18)}px;
    flex: 1;
`
const Value = styled(Texts.RegularText)`
    flex: 3;
`
